import { ButtonsWrapper, Container, DropdownWrapper, LabelsWrapper, MainWrapper } from './service-item.style'
import { getDurationVariants } from '../service-duration/service-duration'
import { Button, Dropdown, MenuProps, theme } from 'antd'
import { MoreOutlined } from '@ant-design/icons'
import { Avatar } from 'components/avatar/avatar'
import { getLocationId, getShopId, setCacheManually, useTranslate, useWindowDimensions } from 'utils'
import { Label } from 'components/styled'
import { Service as Service } from 'types'
import { useNavigate } from 'react-router-dom'

type Props = {
    service: Service
}

export const ServiceItem = ({ service }: Props) => {
    
    const locationId = getLocationId()

    //hooks:
    const { __ } = useTranslate()
    const { token: { paddingXXS, paddingXS, paddingSM, padding, borderRadius } } = theme.useToken()
    const { SM } = useWindowDimensions()
    const navigate = useNavigate()

    //items:
    const items: MenuProps['items'] = [
        { key: 'manage', label: __`manage`},
        { key: 'book'  , label: __`book`  }
    ]

    //on menu clicked:
    const onClick: MenuProps['onClick'] = ({ domEvent, key }) => {
        domEvent.stopPropagation()
        switch(key){
            case 'manage':
                onManageClick()
                break
            case 'book':
                onBookClick()
                break
        }
    }

    //onManageClick:
    const onManageClick = () => {
        setCacheManually(['service', service.id, getShopId()], service)
        navigate(`/service/${service.id}`)
    }

    //onBookClick:
    const onBookClick = () => navigate(`/service/book/${service.id}`)

    const hasDuration = getDurationVariants(service.variants).length > 0
    const hasLocation = service.locations.length > 0
    const hasResource = service.locations.find(l => l.id === locationId && l.resources.length > 0)

    return (
        <Button
            type='text'
            style={{
                width: '100%',
                height: 'auto',
                padding: SM ? 0 : `0 ${padding}px 0 ${paddingSM}px`,
                borderRadius: SM ? borderRadius : 0
            }}
            onClick={onManageClick}
        >

            <MainWrapper>

                {/* image and title */}
                <Avatar
                    name={service.title}
                    image={service.image.path}
                    style={{ paddingLeft: paddingXXS }}
                />

                <Container>
                    
                    {/* labels */}
                    {(!hasResource || !hasDuration) && (
                        <LabelsWrapper>

                            {!hasDuration &&
                                <Label
                                    type='warning'
                                    text={__`no_durations`}
                                />
                            }

                            {!hasLocation ? (
                                <Label
                                    type='warning'
                                    text={__`no_locations`}
                                />
                            ) : !hasResource ? (
                                <Label
                                    type='warning'
                                    text={__`no_resources`}
                                />
                            ) : <></>}

                        </LabelsWrapper>
                    )}
                    
                    {/* actions(button) */}
                    <ButtonsWrapper>
                        <Button
                            type="text"
                            style={{ paddingLeft: paddingXS, paddingRight: paddingXS}}
                            onClick={e => {
                                e.stopPropagation()
                                onManageClick()
                            }}
                        >
                            {__`manage`}
                        </Button>
                        <Button
                            type="text"
                            style={{ paddingLeft: paddingXS, paddingRight: paddingXS}}
                            disabled={!hasResource || !hasDuration}
                            onClick={e => {
                                e.stopPropagation()
                                onBookClick()
                            }}
                        >
                            {__`book`}
                        </Button>
                    </ButtonsWrapper>

                    {/* actions(dropdown) */}
                    <DropdownWrapper>
                        <Dropdown menu={{ items, onClick }} trigger={['click']}>
                            <Button
                                type={'text'}
                                shape={'circle'}
                                size={'large'}
                                icon={<MoreOutlined/>}
                                onClick={e => e.stopPropagation()}
                            />
                        </Dropdown>
                    </DropdownWrapper>
                    
                </Container>

            </MainWrapper>

        </Button>
    )
    
}
